import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, EffectFade, Autoplay } from 'swiper'

import s from './index.module.css'
import './slider.css'
import 'swiper/css'

import 'swiper/css/pagination'
import 'swiper/css/effect-fade'
import { useEffect, useState } from 'react'
import { bannerApi } from '../../../../../api'
import Preloader from '../../../../UI/Preloader'
import BannerCard from '@pages/Admin/BannerManagementV2/components/BannerCard/Banner'

const SliderNewDesign = () => {
  const [banners, setBanners] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    bannerApi
      .index({
        params: { group: 'course' },
      })
      .then(({ data }) => {
        setBanners(data)
        setLoading(false)
      })
  }, [])

  if (loading) {
    return (
      <div className={s.preloader}>
        <Preloader />
      </div>
    )
  }

  return banners?.length ? (
    <Swiper
      effect={'fade'}
      pagination={{ clickable: true }}
      modules={[Pagination, Autoplay]}
      loop={true}
      spaceBetween={20}
      autoplay={{ delay: 5000, disableOnInteraction: false }}
    >
      {banners?.map((banner) => (
        <SwiperSlide key={banner.id} className={s.swiperSlide}>
          <BannerCard banner={banner} className={s.banner} />
        </SwiperSlide>
      ))}
    </Swiper>
  ) : (
    <div></div>
  )
}

export default SliderNewDesign
